// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2AfSj","label":"Section_label__1UJ-j","contentWrap":"Section_contentWrap__KmPPX","footer":"Section_footer__jpPS1","footerInner":"Section_footerInner__bLS8G"};